import { Navigate, useLocation } from "react-router-dom";

export const PrivateRoutes = ({ children }) => {
  const location = useLocation();
  let getTokenFromLocalStorage = null;
  try {
    const customerData = localStorage.getItem("customer");
    if (customerData) {
      getTokenFromLocalStorage = JSON.parse(customerData);
    }
  } catch (error) {
    console.error("Error parsing customer data from localStorage:", error);
    localStorage.removeItem("customer");
  }

  return getTokenFromLocalStorage?.token ? (
    children
  ) : (
    <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />
  );
};
